import React from "react";

import { HubButton } from "../../../components";
import { useCostingSheetUpload } from "./useCostingSheetUpload";

const SendCostingSheetButton = ({ quoteId, disabled }) => {
  const { upload, working } = useCostingSheetUpload({ quoteId });
  const isDisabled = disabled || working || !quoteId;

  return (
    <HubButton
      variant="contained"
      size="xsmall"
      color="neutral"
      icon="UploadCloud"
      iconProps={{ size: 14 }}
      label={working ? "Sending…" : "Send to Google Drive"}
      onClick={upload}
      disabled={isDisabled}
    />
  );
};

export default SendCostingSheetButton;
